import React from 'react'
import './WorkCard.css'

function WorkCard( { src, alt, title, desc, url} ) {
    return (
        <div className="workCard">
            <a href={url} target="_blank">
                <img src={src} alt={alt} />
                <h4>{title}</h4>
                <p>{desc}</p>
            </a>
        </div>
    )
}

export default WorkCard
